module.exports = __webpack_public_path__ + "assets/img/sabc_tv_show_slider_right_arrow.webp?d9a3091e6288f68e2f294654bba689c4";